import api from './api';

/**
 * Vendor invoices billed BY the vendor TO the platform.
 * Backed by the VendorInvoice table (not the customer Invoice table).
 * Lifecycle: draft -> pending -> approved | rejected -> processed (paid).
 */
class InvoiceService {
    /**
     * List a vendor's own vendor-invoices.
     * @param {number} vendorId
     * @param {Object} params - { page, limit, status }
     */
    async getInvoices(vendorId, params = {}) {
        const response = await api.get(`/vendors/${vendorId}/vendor-invoices`, { params });
        return response.data;
    }

    /** Single vendor-invoice by id. */
    async getInvoiceDetail(invoiceId) {
        const response = await api.get(`/invoices/vendor-invoices/${invoiceId}`);
        return response.data;
    }

    /** Presigned PDF download link ({ download_url }). */
    async getInvoiceDownloadLink(invoiceId) {
        const response = await api.get(`/invoices/vendor-invoices/${invoiceId}/download`);
        return response.data;
    }

    /** Edit extra charges on a draft. */
    async updateExtras(invoiceId, extraChargesAmount, extraChargesNotes) {
        const response = await api.patch(`/invoices/vendor-invoices/${invoiceId}/extras`, {
            extra_charges_amount: extraChargesAmount,
            extra_charges_notes: extraChargesNotes || null,
        });
        return response.data;
    }

    /** Confirm a draft -> pending (submitted to the platform for approval). */
    async confirm(invoiceId) {
        const response = await api.post(`/invoices/vendor-invoices/${invoiceId}/confirm`, {});
        return response.data;
    }

    /** Rebuild the PDF when pdf_path is missing. */
    async regeneratePdf(invoiceId) {
        const response = await api.post(`/invoices/vendor-invoices/${invoiceId}/regenerate-pdf`, {});
        return response.data;
    }
}

export const invoiceService = new InvoiceService();
